import React from 'react'

const RegionAccess = () => {
  return (
    <>
      <div>
        <h4>Region Access</h4>
        <p>Assign users to open regions</p>
      </div>
      <hr />
    </>
  )
}

export default RegionAccess